import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../store/slices/auth-slice';

function PrivateRoute() {
  const loggedInUser = useSelector(selectLoggedInUser);
  let location = useLocation();

  return loggedInUser ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}

export default PrivateRoute;
